<div class="modal">
  <!-- Header -->
  <div class="modal-header">
    <div class="header-icon-wrapper">
      <mat-icon class="header-icon">phone_in_talk</mat-icon>
    </div>
    <div class="header-text">
      <p class="header-tag">KAIRON VOICE</p>
      <h2 class="header-title">{{ 'Settings.VoiceSimulateTitle' | translate }}</h2>
    </div>
    <button class="close-button" (click)="onCancel()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Warning Banner -->
  <div class="warning-banner">
    <mat-icon class="warning-icon">warning_amber</mat-icon>
    <span>{{ 'Settings.VoiceSimulateDescription' | translate }}</span>
  </div>

  <!-- Form -->
  <form [formGroup]="form" class="simulation-form">
    <div class="field-group">
      <label class="field-label">
        <span class="field-step">01</span>
        {{ 'Settings.VoiceSimulatePartitionLabel' | translate }}
      </label>
      <mat-form-field appearance="outline" class="full-width" floatLabel="never">
        <mat-label></mat-label>
        <mat-select formControlName="partitionId" id="sim-partition-select">
          <mat-option *ngFor="let p of data.partitions" [value]="p._id"> {{ p.name }} ({{ p.account }}) </mat-option>
        </mat-select>
        <mat-error *ngIf="form.get('partitionId')?.hasError('required')">
          {{ 'Settings.VoiceSimulatePartitionRequired' | translate }}
        </mat-error>
      </mat-form-field>
    </div>

    <div class="field-group">
      <label class="field-label">
        <span class="field-step">02</span>
        <mat-icon class="field-label-icon">smartphone</mat-icon>
        {{ 'Settings.VoiceSimulatePhoneLabel' | translate }}
      </label>
      <mat-form-field appearance="outline" class="full-width" floatLabel="never">
        <mat-label></mat-label>
        <input
          matInput
          formControlName="phone"
          id="sim-phone-input"
          [placeholder]="'Settings.VoiceSimulatePhonePlaceholder' | translate"
          autocomplete="off"
        />
        <mat-hint>{{ 'Settings.VoiceSimulatePhoneHint' | translate }}</mat-hint>
        <mat-error *ngIf="form.get('phone')?.hasError('required')">
          {{ 'Settings.VoiceSimulatePhoneRequired' | translate }}
        </mat-error>
        <mat-error *ngIf="form.get('phone')?.hasError('pattern')">
          {{ 'Settings.VoiceSimulatePhoneInvalid' | translate }}
        </mat-error>
      </mat-form-field>
    </div>

    <div class="field-group">
      <label class="field-label">
        <span class="field-step">03</span>
        <mat-icon class="field-label-icon">vpn_key</mat-icon>
        {{ 'Settings.VoiceSimulateSafeWordLabel' | translate }}
      </label>
      <mat-form-field appearance="outline" class="full-width" floatLabel="never">
        <mat-label></mat-label>
        <input matInput formControlName="safeWord" id="sim-keyword-input" autocomplete="off" />
        <mat-hint>{{ 'Settings.VoiceSimulateSafeWordHint' | translate }}</mat-hint>
      </mat-form-field>
    </div>
  </form>

  <!-- Actions -->
  <mat-dialog-actions class="button-line">
    <button class="btn-cancel" mat-button id="sim-cancel-button" (click)="onCancel()">
      {{ 'Settings.VoiceSimulateCancel' | translate }}
    </button>
    <button class="btn-confirm" mat-button id="sim-confirm-button" [disabled]="form.invalid" (click)="onConfirm()">
      <mat-icon>call</mat-icon>
      {{ 'Settings.VoiceSimulateConfirm' | translate }}
    </button>
  </mat-dialog-actions>
</div>
